import React, { CSSProperties, FC } from 'react';

import { cn } from '../../../../utils';

export type CrossIconPreset =
  | 'default'
  | 'success'
  | 'circle'
  | 'circle-white'
  | 'circle-muted'
  | 'circle-danger';

type OwnProps = {
  preset?: CrossIconPreset;
  size?: number;
  className?: string;
  style?: CSSProperties;
  title?: string;
};

type Props = OwnProps & Omit<React.SVGProps<SVGSVGElement>, keyof OwnProps>;

const CrossIcon: FC<Props> = ({
  preset = 'default',
  size = 24,
  className,
  style,
  title = 'Close',
  ...svgProps
}) => {
  const isCircle =
    preset === 'circle' ||
    preset === 'circle-white' ||
    preset === 'circle-muted' ||
    preset === 'circle-danger';

  const iconColor =
    preset === 'success'
      ? 'var(--primary-green-new)'
      : preset === 'circle-white'
        ? 'var(--white-color)'
        : preset === 'circle-danger'
          ? 'var(--red-color)'
          : preset === 'circle-muted'
            ? 'var(--gray-color-3)'
            : '#111';

  const circleStrokeColor =
    preset === 'circle-white'
      ? 'var(--white-color)'
      : preset === 'circle-danger'
        ? 'var(--red-color)'
        : preset === 'circle-muted'
          ? 'var(--gray-color-3)'
          : '#111';

  const backgroundColor = preset === 'circle-muted' ? 'var(--gray-color-3)' : undefined;

  const strokeWidth = 1.5;
  const circleStrokeWidth = 1.5;
  const circleInnerScale = 0.75;

  return (
    <svg
      className={cn(className)}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      style={{ width: size, height: size, color: iconColor, ...style }}
      {...svgProps}
    >
      {backgroundColor ? <rect x="0" y="0" width="24" height="24" fill={backgroundColor} /> : null}
      {isCircle ? (
        <circle
          cx="12"
          cy="12"
          r={11 - circleStrokeWidth / 2}
          stroke={circleStrokeColor}
          strokeWidth={circleStrokeWidth}
        />
      ) : null}

      <g
        transform={
          isCircle ? `translate(12 12) scale(${circleInnerScale}) translate(-12 -12)` : undefined
        }
      >
        <path
          d="M18 6L6 18"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 6L18 18"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default CrossIcon;
